"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieDomain = void 0;
const getCookieDomain = (domain) => (window.ENVIRONMENT !== 'prod' ? `.${window.ENVIRONMENT}${domain}` : domain);
exports.getCookieDomain = getCookieDomain;
//# sourceMappingURL=helper.js.map